import { ICellRendererParams } from 'ag-grid-community';
import moment from 'moment-timezone';
import React from 'react';
// @ts-ignore
// eslint-disable-next-line @typescript-eslint/no-redeclare

export interface IGridDateTimeRenderer extends ICellRendererParams {
    dataKey: string;
    color: string;
    timezone: string
    dateTimeFormat: string
}

const GridDateTimeRenderer: React.FC<IGridDateTimeRenderer> = (props) => {
  const propertyValue = props.data[props.dataKey]
  const dateTime = moment.tz(propertyValue,props.timezone);
  const formatDateTime = dateTime.format(props.dateTimeFormat)
  return (
    <span style={{color: props.color}}>{formatDateTime}</span>
  );
};
export default GridDateTimeRenderer;

